const WIKI_URL = 'https://bbgithub.dev.bloomberg.com/bbnpm/bb-analytics/wiki';

// NOTE - This code is taken from https://github.com/sindresorhus/camelcase, but has changed to be compatible with IE11.
function preserveCamelCase(string: string): string {
  let isLastCharLower = false;
  let isLastCharUpper = false;
  let isLastLastCharUpper = false;
  let str = string;

  for (let i = 0; i < str.length; i++) {
    const character = str[i];

    if (
      isLastCharLower &&
      /[a-zA-Z]/.test(character) &&
      character.toUpperCase() === character
    ) {
      str = [str.slice(0, i), str.slice(i)].join('-');
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (
      isLastCharUpper &&
      isLastLastCharUpper &&
      /[a-zA-Z]/.test(character) &&
      character.toLowerCase() === character
    ) {
      str = [str.slice(0, i - 1), str.slice(i - 1)].join('-');
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower =
        character.toLowerCase() === character &&
        character.toUpperCase() !== character;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper =
        character.toUpperCase() === character &&
        character.toLowerCase() !== character;
    }
  }

  return str;
}

function camelcase(input: string): string {
  if (typeof input !== 'string') {
    throw new TypeError('Expected the input to be `string`');
  }

  let str = input.trim();

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  const hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str
    .replace(/^[_.\- ]+/, '')
    .toLowerCase()
    .replace(/[_.\- ]+(\w|$)/g, (_, p1) => p1.toUpperCase())
    .replace(/\d+(\w|$)/g, m => m.toUpperCase());
}

function safeNotification(message: string, safe: boolean) {
  if (safe) {
    console.warn(message); // eslint-disable-line no-console
  } else {
    throw new Error(message);
  }
}

export function isCamelCase(input: string): boolean {
  return input === '' || (!!input && input === camelcase(input));
}

/* NOTE - The recommended standard for category, action, and label is camel-case with pipe delimiters only.
This method does a check to ensure that standard is being followed. It is only used in debug mode */
export function containsDelimiterOutsideRecommendedStandard(
  str: string
): boolean {
  if (str) {
    const parts = str.split('|');
    if (parts.length === 1) {
      return !isCamelCase(str) || /,|\.|\\|\/|-|_|\+|\s/.test(str);
    } else {
      return parts.some(
        (part, index) =>
          !part ||
          containsDelimiterOutsideRecommendedStandard(
            (() => {
              if (index === 0) {
                return part.replace(/\s$/g, '');
              } else if (index === parts.length - 1) {
                return part.replace(/^\s/g, '');
              } else {
                return part.replace(/^\s|\s$/g, '');
              }
            })()
          )
      );
    }
  }
  return false;
}

export function validateReportingStandards({
  key,
  value,
  safe = false,
}: {
  key: string;
  value: string;
  safe?: boolean;
}) {
  if (containsDelimiterOutsideRecommendedStandard(value)) {
    safeNotification(
      `${key}: "${value}" is outside of the recommended camel-case & pipe delimiter standard. Please refer to ${WIKI_URL} for the recommended standard.`,
      safe
    );
  }
}
